import { render, staticRenderFns } from "./exposure.vue?vue&type=template&id=53919972&scoped=true&"
import script from "./exposure.vue?vue&type=script&lang=js&"
export * from "./exposure.vue?vue&type=script&lang=js&"
import style0 from "./exposure.vue?vue&type=style&index=0&id=53919972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53919972",
  null
  
)

export default component.exports